// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3YijN","tab":"ProcedureTabs_tab__1G526"};